import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
      primary: {
          main: '#689f38',
        },
        secondary: {
          main: '#f06292',
        },
    },
  });

export default theme;